import { cn } from '@/lib/utils';
import { padelAvatarColor, padelInitials } from './padelUiUtils';

interface PadelPlayerAvatarProps {
  name: string;
  avatarUrl?: string;
  colorKey?: string;
  className?: string;
}

export default function PadelPlayerAvatar({
  name,
  avatarUrl,
  colorKey,
  className,
}: PadelPlayerAvatarProps) {
  if (avatarUrl) {
    return (
      <img src={avatarUrl} alt={name} className={cn('rounded-full object-cover', className)} />
    );
  }
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full font-bold',
        padelAvatarColor(colorKey ?? name),
        className
      )}
      aria-hidden
    >
      {padelInitials(name)}
    </div>
  );
}
